import { Injectable, Signal, signal } from '@angular/core';
import { FilingLoaderStrategy } from './filing-loader.strategy';

/**
 * Inert strategy used by the `'skeleton'` loader mode.
 *
 * This is intentionally a true no-op — the legacy UX is "no page-level overlay;
 * each sheet shows its own inline spinner via `ConversionProgressService`."
 * That per-sheet path is independent of the filing-loader subsystem and keeps
 * working regardless of which strategy is active.
 *
 * All signals return static, never-mutated values so any UI bound to them
 * stays in its empty state.
 *
 * @see docs/ui/loaders/filing/README.md
 */
@Injectable()
export class NoOpFilingLoaderStrategy extends FilingLoaderStrategy {
  readonly isActive: Signal<boolean> = signal(false).asReadonly();
  readonly phaseLabel: Signal<string> = signal('').asReadonly();
  readonly currentSheetLabel: Signal<string | null> = signal<string | null>(null).asReadonly();
  readonly completedCount: Signal<number> = signal(0).asReadonly();
  readonly totalCount: Signal<number> = signal(0).asReadonly();
  readonly elapsedMs: Signal<number> = signal(0).asReadonly();
  readonly lastCompletedElapsedMs: Signal<number | null> = signal<number | null>(null).asReadonly();

  begin(_initialPhase?: string): void {
    // no-op
  }

  reportPhase(_label: string): void {
    // no-op
  }

  reportSheet(_sheetLabel: string, _completed: number, _total: number): void {
    // no-op
  }

  end(): void {
    // no-op
  }

  acknowledgeCompletion(): void {
    // no-op
  }
}
